//import { checkTokenExists, setToken } from '../helpers/auth';
export const SET_BEFORE_TAB = 'SET_BEFORE_TAB';
export const SET_AFTER_TAB = 'SET_AFTER_TAB';
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION';
export const RESET_STATE = 'RESET_STATE';

export const setQuestionAsync = (question) => dispatch => {
  return new Promise(resolve => {
    dispatch(setQuestion(question));
    return resolve();
  });
};

export const setBeforeTab = (tab) => ({
  type: SET_BEFORE_TAB,
  tab
});

export const setAfterTab = (tab) => ({
  type: SET_AFTER_TAB,
  tab
});

export const setQuestion = (question) => ({
  type: SET_CURRENT_QUESTION,
  question
});

export const resetQuestionsState = () => ({
  type: RESET_STATE
});